module.exports = __webpack_public_path__ + "static/media/permission.2f5cb43.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/permission.mp4
// module id = w+ks
// module chunks = 0